<template>
  <div>
    <VanPopup
      :value="show"
      round
      safe-area-inset-bottom
      position="bottom"
      overlay-class="custom-van-popup-overlay"
      class="custom-van-popup"
      @click-overlay="onClickClose"
      @close="onClickClose"
    >
      <div class="cancel-confirm">
        <div class="header">
          <div class="title">取消订单</div>
          <div class="rule" @click="onClickRefundRule">退款规则</div>
        </div>
        <div class="row">订单金额：{{ actualPrice }}元</div>
        <div class="row">退款金额：{{ actualPrice }}元</div>
        <div class="bottom">
          <VanButton class="btn cancel" @click="onClickRefund"
            >确认取消</VanButton
          >
          <VanButton class="btn" @click="onClickClose">再想想</VanButton>
        </div>
      </div>
    </VanPopup>
  </div>
</template>

<script>
import { fenToYuan } from "@/utils";

export default {
  name: "cancelConfirm",
  model: {
    prop: "show",
    event: "change",
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    record: {
      type: Object,
      default() {
        return {
          id: "",
          price: "",
        };
      },
    },
  },
  data() {
    return {};
  },
  computed: {
    actualPrice() {
      return fenToYuan(this.record ? this.record.actualPrice : '');
    },
  },
  methods: {
    onClickRefund() {
      this.$emit("refund", this.record.id);
    },
    onClickClose() {
      this.$emit("change", false);
    },
    onClickRefundRule() {
      this.$emit("rule");
    },
  },
};
</script>

<style scoped lang="scss">
.cancel-confirm {
  background: linear-gradient(180deg, #bddeff 0%, #ffffff 100%),
    linear-gradient(216deg, #d9fff3 0%, rgba(255, 255, 255, 0) 100%);
  padding: 0 20px;
  .header {
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }

  .title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 16px;
    color: #000000;
    line-height: 22px;
  }

  .rule {
    position: absolute;
    right: 0;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #006efa;
    line-height: 20px;
  }
  .row {
    height: 40px;
    display: flex;
    align-items: center;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.6);
    line-height: 22px;
  }
  .bottom {
    display: flex;
    margin: 20px 0;
  }
  .btn {
    flex: 1;
    height: 48px;
    border-radius: 25px;
    background: linear-gradient(90deg, #00a7fd 0%, #006efa 100%);
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #ffffff;
    line-height: 22px;
  }

  .cancel {
    background: #eceff3;
    color: #999999;
    margin-right: 10px;
  }
}
</style>
